<template>
  <div class="container-results-proposals mx-auto" :class="{ 'is-embedded': is_embedded }">
    <b-col class="filters-fixed-nav mb-1" ref="filters_fixed">
      <div class="max-width-1400 container-filters-casting-calls">
        <div class="container-button-filters-trash" style="position: relative;">
          <strong class="title-all-campaigns h3 mb-0">{{$t('creator.totalCasting')}}</strong>
          <div class="filter-btn-group">
            <button
              class="fbg-filter"
              :class="{ 'has-filters': filters_used_number > 0 }"
              @click="open_modal = !open_modal; update_modal = !update_modal;">
              <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24">
                <line x1="4" y1="6" x2="20" y2="6"/>
                <line x1="8" y1="12" x2="16" y2="12"/>
                <line x1="11" y1="18" x2="13" y2="18"/>
              </svg>
              {{$t('search.filters')}}
              <span class="fbg-badge" v-if="filters_used_number > 0">{{filters_used_number}}</span>
            </button>
            <button class="fbg-trash" @click="clearFilters" :title="$t('creator.clearFilter')">
              <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                <path d="M10 11v6M14 11v6"/>
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            </button>
          </div>
          <filter-search-casting-call
            :key="filter_reset_key"
            :open_modal="open_modal"
            :filters_layout="filters_layout"
            @filter="filterAction"
          ></filter-search-casting-call>
          <div class="top-pagination" v-if="total_casting_calls > per_page">
            <span class="top-pagination-label">{{current_page}} / {{total_pages}}</span>
            <pagination-brandme
              :total_rows="total_casting_calls"
              :per_page="per_page"
              :current_page="current_page"
              @update_current_page="updateCurrentPage"
            ></pagination-brandme>
          </div>
        </div>
      </div>
    </b-col>
    <transition name="fade-more-below">
      <div class="more-below-hint" v-if="has_more_below && !loader_results">
        <div class="more-below-fade"></div>
        <button class="more-below-button" @click="scrollDown">
          {{$t('creator.moreCampaignsBelow')}}
          <feather-icon icon="ChevronsDownIcon" class="more-below-icon"></feather-icon>
        </button>
      </div>
    </transition>
    <b-col class="min-height-500 text-campaign-custom" ref="results_container">
      <div class="col-12 mb-2" v-if="$route.query.query && casting_calls.length > 0 && !loader_results">
        <span class="h5">{{$t('creator.searchBy')}} "{{$route.query.query}}"</span>
      </div>
      <div v-if="!loader_results" class="row m-0">
        <div class="grid-search-proposal w-100 position-relative" :key="loader_results">
          <div v-for="(casting_call) in casting_calls" :key="casting_call.uuid" class="responsive-xs">
            <card-casting-call :redirect="true" class="mb-2" :casting_call="casting_call"></card-casting-call>
          </div>
        </div>
      </div>
      <div class="w-100" v-else>
        <loader-video-brandme :text_loading="'creator.loading'" :position_class="'position-relative'"></loader-video-brandme>
      </div>
      <b-col class="empty-state-container-proposals" v-if="casting_calls.length === 0 && !loader_results">
        <no-Results
          :title="`${$t('creator.noResults')} ${$route.query.query ? $route.query.query : ''}`"
          :subtitle="$t('creator.textFilters')"
          :text_button="$t('creator.backCampaign')"
          :btn_action="clearFilters"
          :show_icon="false"
          :class_btn="'blue-button mt-1'"
        />
      </b-col>
      <pagination-brandme
        class="col-12 d-flex justify-content-center mt-2"
        :total_rows="total_casting_calls"
        :per_page="per_page"
        :current_page="current_page"
        @update_current_page="updateCurrentPage"
        v-if="total_casting_calls > per_page"
      ></pagination-brandme>
    </b-col>
  </div>
</template>

<script>
import { BCol } from 'bootstrap-vue';
import casting_calls_services from '@/services/casting_calls';
import { getUrlCategory } from '@/libs/utils/urls';
import { getUserData } from '@/libs/utils/user';

export default {
  name: 'wordpressMarcas',
  components: {
    BCol,
    cardCastingCall: () => import('@/views/components/casting-calls/cardCastingCall.vue'),
    filterSearchCastingCall: () => import('@/views/components/casting-calls/filterSearchCastingCall.vue'),
    noResults: () => import('@/views/pages/proposals/stepper/noResults.vue'),
    paginationBrandme: () => import('@/views/components/pagination/PaginationBrandme.vue'),
    LoaderVideoBrandme: () => import('@/views/components/banner/LoaderVideoBrandme.vue'),
  },
  data() {
    return {
      create_proposal: false,
      getUrlCategory,
      casting_calls: [],
      current_page: 1,
      filters_used_number: 0,
      per_page: 10,
      total_casting_calls: 0,
      open_modal: false,
      update_modal: false,
      filter_reset_key: 0,
      loader_results: false,
      filters_layout: [],
      filters: {},
      filter_button_selected: {
        selected: false,
        type_button: '',
        list_button: [],
      },
      has_more_below: false,
      resize_observer: null,
      is_embedded: window.parent !== window,
      last_height_sent: 0,
    };
  },
  computed: {
    total_pages() {
      return Math.ceil(this.total_casting_calls / this.per_page);
    },
  },
  mounted() {
    window.addEventListener('scroll', this.checkMoreBelow, { passive: true });
    window.addEventListener('resize', this.checkMoreBelow);
    // Las imágenes de las cards cambian el alto después de cargar
    if (window.ResizeObserver) {
      this.resize_observer = new ResizeObserver(this.onContentResize);
      this.resize_observer.observe(this.$el);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkMoreBelow);
    window.removeEventListener('resize', this.checkMoreBelow);
    if (this.resize_observer) this.resize_observer.disconnect();
  },
  created() {
    const user = getUserData();
    if (user) {
      this.create_proposal = user.meta_info && user.meta_info.vanity_name;
    }
    const body = document.getElementsByTagName('body')[0];
    body.style.backgroundColor = 'white';
    this.$root.$on('update_casting_calls', (selected_button) => {
      if (selected_button) this.filter_button_selected = selected_button;
      this.addFiltersFromParams();
      this.loader_results = true;
      this.getCastingCalls();
      this.$root.$emit('update_color_button_selected', this.filter_button_selected);
    });
    this.addFiltersFromParams();
    this.loader_results = true;
    this.getCastingCalls();
  },
  destroyed() {
    const body = document.getElementsByTagName('body')[0];
    body.removeAttribute('style');
    this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', false);
  },
  methods: {
    onContentResize() {
      this.checkMoreBelow();
      this.sendHeightToParent();
    },
    sendHeightToParent() {
      // Dentro del iframe de WordPress le avisamos al padre el alto real para que ajuste el iframe
      if (!this.is_embedded) return;
      const height = Math.ceil(this.$el.getBoundingClientRect().top + window.scrollY + this.$el.scrollHeight);
      if (height === this.last_height_sent) return;
      this.last_height_sent = height;
      window.parent.postMessage({ type: 'brandme-iframe-height', height }, '*');
    },
    checkMoreBelow() {
      // Embebido, WordPress ajusta el alto del iframe y el scroll es el de la página padre.
      // En iOS el iframe no recibe 'resize' al cambiarle el alto, así que el aviso quedaría visible tapando la paginación
      if (this.is_embedded) {
        this.has_more_below = false;
        return;
      }
      const scroll_bottom = window.innerHeight + (window.scrollY || document.documentElement.scrollTop);
      this.has_more_below = document.documentElement.scrollHeight - scroll_bottom > 120;
    },
    scrollDown() {
      window.scrollBy({ top: window.innerHeight * 0.8, behavior: 'smooth' });
    },
    updateCurrentPage(new_current_page) {
      this.current_page = new_current_page;
      this.getCastingCalls();
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      if (this.is_embedded) window.parent.postMessage({ type: 'brandme-iframe-scroll-top' }, '*');
    },
    redirectOption() {
      const url = this.create_proposal ? this.$router.resolve({ name: 'steps_proposal', params: { step: 'category' } }).href : this.$router.resolve({ name: 'my_work', params: { section: 'networks' } }).href;
      window.open(`${window.location.origin}${url}`, '_blank');
    },
    addFiltersFromParams() {
      const query = {};
      if (Object.keys(this.$route.query).length > 0) {
        if (this.$route.query.content_type) {
          if (Object.keys(this.filters).length === 0) this.filters.content_types = [this.$route.query.content_type];
          else this.filters.content_types.push(this.$route.query.content_type);
        } else if (this.$route.query.query) {
          query.query = this.$route.query.query;
          this.filters = query;
        } else if (this.$route.query.network) {
          query.work_types = [this.$route.query.network];
          this.filters = query;
        }
      }
    },
    clearFilters(update = true) {
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.push({ name: 'wordpress_marcas' });
      }
      this.filter_button_selected.selected = false;
      this.filter_button_selected.type_button = '';
      this.filter_button_selected.list_button = [];
      this.filters_layout = [];
      this.filters = {};
      this.filters_used_number = 0;
      this.current_page = 1;
      this.filter_reset_key++;
      this.$root.$emit('update_search_query', '');
      this.$root.$emit('update_color_button_selected', this.filter_button_selected);
      this.loader_results = true;
      if (update) this.getCastingCalls();
    },
    filterAction(filters, filters_used_number, filters_layout) {
      this.open_modal = false;
      this.update_modal = !this.update_modal;
      this.filters_used_number = filters_used_number;
      this.filters_layout = filters_layout;
      this.filters = Object.assign({}, this.filters, filters);
      this.current_page = 1;
      this.loader_results = true;
      this.getCastingCalls();
    },
    getCastingCalls() {
      const query = { ...this.filters };
      this.casting_calls = [];
      this.loader_results = true;
      casting_calls_services.getCastingCalls(query, this.per_page, this.current_page).then((response) => {
        this.total_casting_calls = response.count;
        this.casting_calls = response.results;
        this.loader_results = false;
        this.$nextTick(this.checkMoreBelow);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.grid-search-proposal {
  display: grid;
  grid-template-columns: repeat(5, minmax(100px, 1fr));
  grid-gap: 2rem;
  grid-auto-flow: dense;
}
@media(max-width: 1200px) {
  .grid-search-proposal {
    grid-template-columns: repeat(4, minmax(100px, 1fr));
  }
}
@media(max-width: 1000px) {
  .grid-search-proposal {
    grid-template-columns: repeat(3, minmax(100px, 1fr));
  }
}
@media(max-width: 700px) {
  .grid-search-proposal {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }
}
@media(max-width: 450px) {
  .grid-search-proposal {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 1rem;
  }
}
.container-filters-casting-calls {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;

  .container-button-filters-trash {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.5rem;
    width: 100%;
    margin-bottom: 0.5em;
  }
  .title-all-campaigns {
    color: #3d3d5c;
    white-space: nowrap;
  }
  .filter-btn-group {
    display: inline-flex;
    align-items: center;
    background: #fff;
    border: 1.5px solid #e8e8f0;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    transition: box-shadow 0.2s;
    &:hover { box-shadow: 0 4px 16px rgba(115,103,240,0.1); }
  }
  .fbg-filter {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 7px 14px;
    font-size: 13px; font-weight: 700; color: #555;
    cursor: pointer; border: none; outline: none; background: transparent;
    border-right: 1.5px solid #e8e8f0;
    transition: color 0.15s, background 0.15s;
    &:hover, &:focus { background: #f7f5ff; color: #7367f0; box-shadow: none; }
    &.has-filters { color: #7367f0; }
  }
  .fbg-badge {
    background: #7367f0; color: #fff;
    border-radius: 999px; font-size: 10px; font-weight: 800;
    padding: 1px 6px; line-height: 1.5;
  }
  .fbg-trash {
    display: inline-flex; align-items: center; justify-content: center;
    width: 36px; padding: 7px 0;
    border: none; outline: none; background: transparent;
    color: #ccc; cursor: pointer;
    transition: color 0.15s, background 0.15s;
    &:hover, &:focus { background: #fff1f1; color: #e05252; box-shadow: none; }
  }
  @media(max-width: 730px) {
    justify-content: center;
  }
  .top-pagination {
    display: none;
  }
  @media(max-width: 576px) {
    .top-pagination {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
    .top-pagination-label {
      font-size: 13px;
      font-weight: 700;
      color: #6e6b7b;
    }
  }
}
.more-below-hint {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 40;
  display: flex;
  justify-content: center;
  padding-bottom: 14px;
  pointer-events: none;

  .more-below-fade {
    position: absolute;
    inset: 0;
    height: 90px;
    top: auto;
    background: linear-gradient(to bottom, rgba(255,255,255,0), #fff 85%);
  }
  .more-below-button {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border: none;
    border-radius: 999px;
    background: #7367f0;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 4px 14px rgba(115,103,240,0.35);
    cursor: pointer;
    pointer-events: auto;
    animation: more-below-bounce 1.8s ease-in-out infinite;
  }
  .more-below-icon {
    width: 16px;
    height: 16px;
  }
}
.fade-more-below-enter-active, .fade-more-below-leave-active {
  transition: opacity 0.25s;
}
.fade-more-below-enter, .fade-more-below-leave-to {
  opacity: 0;
}
@keyframes more-below-bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}
.text-campaign-custom {
  color: black;
}
.min-height-500 {
  min-height: 80vh;
}
// En el iframe el alto lo define el contenido; 80vh dependería del alto del propio iframe
.is-embedded .min-height-500 {
  min-height: 500px;
}
.empty-state-container-proposals {
  margin: 11em 0;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  text-align: center;
}
.max-width-1400 {
  max-width: 1400px;
  margin: 0px auto;
}
.filters-fixed-nav {
  background-color: white;
  position: sticky;
  display: block;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 50;
  box-shadow: 0px 10px 5px white;
  padding: 0.5em 0 0 0;
}
.container-results-proposals {
  max-width: 1440px;
  width: 100%;
  padding: 0 1rem;
}
@media(max-width: 576px) {
  .responsive-xs {
    display: flex;
    justify-content: center;
  }
}
@keyframes filters-fixed {
  0% {
    transform: translateY(-200px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
</style>
